import BlockBenefitsListing from './benefitsListing'

export default BlockBenefitsListing
